window.addEventListener("load", function () {
  if ($("#swiperFeature").length > 0) {
    let thumbsSwiper = null;

    // Only initialize thumbs swiper if element exists and is visible
    if ($("#swiperFeatureThumb").length > 0) {
      thumbsSwiper = new Swiper("#swiperFeatureThumb", {
        slidesPerView: 3,
        spaceBetween: 20,
        direction: "vertical",
        slideToClickedSlide: true,
        breakpoints: {
          751: {
            slidesPerView: 7,
          },
        },
      });
    }

    const mainSwiper = new Swiper("#swiperFeature", {
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 0,
      thumbs: {
        swiper: thumbsSwiper,
      },
      navigation: {
        nextEl: ".swiper-button-next--swiperFeature",
        prevEl: ".swiper-button-prev--swiperFeature",
      },
    });
  }
});
